import { Link, Text, Page, View } from '@react-pdf/renderer';
import { en } from '../../theme/languages/en';
import { Footer, Header } from '../../components';
import { DocumentState, Supplier } from '../../../common';
import { styles } from './PageComponent.module';

interface PageComponentProps {
  children?: React.ReactNode;
  supplier?: Supplier;
  isPreview?: boolean;
  paymentLink?: string;
  isSample?: boolean;
  hasCreditCardPayment?: boolean;
  documentState?: DocumentState;
}

export const PageComponent = ({
  children,
  supplier,
  paymentLink,
  isSample,
  documentState,
  hasCreditCardPayment,
}: PageComponentProps) => {
  return children ? (
    <Page style={styles.page} size="A4" wrap>
      {!isSample && <Header supplier={supplier} documentState={documentState} />}
      {children}
      <Footer
        children={
          <View
            style={styles.payButtonView}
            render={({ pageNumber }) =>
              hasCreditCardPayment &&
              pageNumber === 1 && (
                <Link style={!paymentLink ? styles.payButtonDisabled : styles.payButton} src={paymentLink}>
                  <Text style={styles.payButtonLabel}>{en.payWithCreditCard}</Text>
                </Link>
              )
            }
          ></View>
        }
      />
    </Page>
  ) : (
    <></>
  );
};
